import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class HeroImage extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get header() {
    return get(this, '_header.value', '');
  }

  get description() {
    return get(this, '_description.value', '');
  }

  get backgroundDesks() {
    return get(this, '_background_desks.value[0].url', '');
  }

  get backgroundHand() {
    return get(this, '_background_hand.value[0].url', '');
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }

  get floatingElements() {
    return get(this, '_floating_elements', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/HeroImage.model.js